import { gql } from "@apollo/client";
export const getProcessedEvidenceByFileId = gql`
  query getProcessedEvidenceByFileId(
    $file_id: Int!
    $end_time: DateTime
  ) {
    getProcessedEvidenceByFileId(
      file_id: $file_id
      end_time: $end_time
    ) {
      id
      path
      entityId
      entityType
      checks {
        checkId
        checkName
        checkStatus
        checkCategory
        checkType
        monitorType
        checkDescription
      }
    }
  }
`;

export const getEvidencesByEmployee = gql`
  query getEvidencesByEmployee(
    $employeeName: String
    $employeeEmail: String
    $end_time: DateTime
  ) {
    getEvidencesByEmployee(
      employeeName: $employeeName
      employeeEmail: $employeeEmail
      end_time: $end_time
    ) {
      id
      path
      check_id
      entity_type
      entity_id
      checkmate_metadata
      created_at
      updated_at
    }
  }
`;
